@import '~@tdcerhverv/sass-utils/_util';
@import '~@tdcerhverv/parrotfish/dist/colors-design-token.scss';

.paragraph {
  font-family: 'TDC', Arial, Helvetica, sans-serif;
  margin-bottom: rem(24);
  color: map-get($theme, 'black');
}

.paragraph__small {
  font-size: rem(12);
  line-height: rem(16);
}

.paragraph__medium {
  font-size: rem(14);
  line-height: rem(20);
}

.paragraph__large {
  font-size: rem(16);
  line-height: rem(24);
}

.paragraph__thin {
  font-weight: 100;
}

.paragraph__regular {
  font-weight: 400;
}

.paragraph__strong {
  font-weight: 700;
}

.paragraph__left {
  text-align: left;
}

.paragraph__center {
  text-align: center;
}

.paragraph__right {
  text-align: right;
}

.paragraph__justify {
  text-align: justify;
}

.paragraph__uppercase {
  text-transform: uppercase;
}

.paragraph__emphasis {
  font-style: italic;
}

.paragraph__light_colored {
  color: map-get($theme, 'white');
}
